import React, { useEffect, useState } from "react";
import { TextField, Select, MenuItem, Button, Box, Typography, Autocomplete, Grid } from "@mui/material";
import { ReactComponent as PlushIcon } from "../../assets/dashboardIcons/plusicon.svg"
import { ReactComponent as Wifi } from "../../assets/dashboardIcons/wifiIcon.svg"
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useForm, Controller } from "react-hook-form";
import MenuWithPDF from "../filter/MenuWithPDF";
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { useDispatch, useSelector } from "react-redux";
import { fetchStabilimenti } from "../../features/stabilimenti/stabilimentiThunk";
import produzioniFormAPI from "../../services/produzioniFormApi";
dayjs.locale('it');

// const productOptions = ["Product A", "Product B", "Product C"];

const TableInpItImbottigliamento = ({ option, rows, setRows, activeStep }) => {
    const dispatch = useDispatch();
    const singleProduzioneID = useSelector((state) => state.produzioni.singleProduzioneId);
    const stabiliOptions = useSelector((state) => state.stabilimenti.stabilimenti) || [];

    const { control, setValue, formState: { errors } } = useForm();
    // const [rows, setRows] = useState([
    //     { id: 1, datetime: null, lotto: "", Stabilimento: "", temperature: "" },
    //     { id: 2, datetime: null, lotto: "", Stabilimento: "", temperature: "" },
    // ]);

    useEffect(() => {
        dispatch(fetchStabilimenti());
    }, [dispatch])

    const handleInputChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([
            ...rows,
            { company_id: Number(localStorage.getItem('company_id')) || "", step: activeStep, prod_id: singleProduzioneID, date_imottigliamento: null, lotto_di_produzione: "", stabili_id: "", temp_stoccaggio: "" },
        ]);
    };
    const handleDelete = async (index) => {
        const row = rows[index];
    
        if (row.id) {
          try {
            await produzioniFormAPI.deleteStepFormRow({
                id: row.id, 
                formName: "stoccaggio"
            });
          } catch (err) {
            console.error("Error deleting row from server:", err);
            return;
          }
        }

        setRows((prev) => prev.filter((_, i) => i !== index));
      };
    return (
        <Box className="tableInput" sx={{ maxWidth: "100%", padding: 2 }}>
            {/* Heading */}
            <h3 className="sectiontitleSmall">Imbottigliamento e stoccaggio</h3>

            {/* Column Titles */}
            <Grid container spacing={1} sx={{ marginBottom: 1, fontWeight: "bold", color: "gray" }}>
                <Grid size={.5}><Typography>ID</Typography></Grid>
                <Grid size={2.5}><Typography>Data imottigliamento</Typography></Grid>
                <Grid size={3.2}><Typography>Lotto di produzione</Typography></Grid>
                <Grid size={3.2}><Typography>Stabilimento di stoccaggio</Typography></Grid>
                <Grid size={2.5}>
                    <Box className="inputBoxIcon heading">
                        <p>
                            Temperature di stoccaggio
                        </p>
                        <Wifi className="wifiIcon" />
                    </Box>
                </Grid>
            </Grid>

            {/* Dynamic Rows */}
            {rows?.map((row, index) => (
                <>

                    <Grid container spacing={1} key={index} sx={{ marginBottom: 1 }}>
                        <Grid size={.5}>

                            <TextField
                                className="customTextBox"
                                label="ID"
                                size="small"
                                value={row?.id || index}
                                disabled
                            />
                        </Grid>

                        <Grid size={2.5}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                                <Controller
                                    name={`datetime-${index}`}
                                    control={control}
                                    render={({ field }) => (
                                        <DatePicker
                                            className='datePickerField'
                                            label="Data imottigliamento"
                                            value={row.date_imottigliamento ? dayjs(row.date_imottigliamento) : null}
                                            onChange={(newValue) => {
                                                const formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                                                handleInputChange(index, "date_imottigliamento", formattedDate);
                                                field.onChange(formattedDate);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    error={!!errors[`datetime-${index}`]}
                                                    helperText={errors[`datetime-${index}`]?.message}
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={3.2}>
                            <TextField
                                className="customTextBox"
                                label="Lotto di produzione"
                                value={row.lotto_di_produzione}
                                onChange={(e) => handleInputChange(index, "lotto_di_produzione", e.target.value)}
                                size="small"
                            />
                        </Grid>
                        <Grid size={3.2}>
                            <Autocomplete
                                options={stabiliOptions}
                                getOptionLabel={(option) => option.nome || ""}
                                value={stabiliOptions.find((option) => option.id == row.stabili_id) || null}
                                onChange={(event, newValue) => handleInputChange(index, "stabili_id", newValue?.id)}
                                renderInput={(params) => (
                                    <TextField {...params} className="customTextBox autoCompleteTextBox" label="Stabilimento di stoccaggio" size="small" />
                                )}
                            />
                        </Grid>



                        <Grid size={2.5}>
                            <Box className="inputBoxIcon">
                                <TextField
                                    className="customTextBox"
                                    label="Temperature di stoccaggio"
                                    value={row.temp_stoccaggio}
                                    onChange={(e) => handleInputChange(index, "temp_stoccaggio", e.target.value)}
                                    size="small"
                                />
                                <Wifi className="wifiIcon" />
                            </Box>

                        </Grid>
                        <Grid size={.1}>
                            <MenuWithPDF
                                options={option}
                                handleDelete={(event) => {
                                    event?.stopPropagation();
                                    handleDelete(index);
                                }}
                            />
                        </Grid>
                    </Grid>
                </>
            ))}

            {/* Add Button */}
            <Button
                variant="body2"
                onClick={addRow}
                sx={{
                    cursor: 'pointer', color: "#225CA6", mt: 1, gap: "6px",
                    fontFamily: '"Public Sans", sans-serif !important',
                    '&:hover': {
                        color: '#57C700',
                        background: "transparent"
                    }
                }}
            >
                <PlushIcon

                /> aggiungi lotto di imbottigliamento
            </Button>

        </Box>
    );
};

export default TableInpItImbottigliamento;
